import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../api/api.service';
import { IDashboardActivitiesResponse, IDashboardStatsResponse } from '../../../_models/dashboard.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  private readonly endpoint = "admin";
   
  constructor(private apiService: ApiService) {}


   getStats(dateRange: string = '30d') {
    const params = new HttpParams().set('dateRange', dateRange);
    return this.apiService.get<IDashboardStatsResponse>({
      Url: `${this.endpoint}/dashboard/stats`,
      Params: params
    });
  }

  getAdminDashboardActvities(){
    return this.apiService.get<IDashboardActivitiesResponse>({
      Url : `${this.endpoint}/dashboard/activities`
    })
  }
}
